/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Status for CanStopRecording web-api call
 */ 
export enum CanStopRecordingErrorCode {
    Undefined = 0,
    Ok = 1,
    ScenarioRecordingNotFound = 2,
    ScenarioRecordingTooShort = 3,
}
